
import { Injectable } from '@angular/core';
import { DistriApiService } from '../distri/distri.api.service';
import { Banque } from '../../model/index';

@Injectable()
export class BanqueService {

    private readonly apiPath = 'common/banques';

    constructor(private apiService: DistriApiService) {}

    async getList() {
        try {
            const data = await this.apiService.get(this.apiPath + '/search/actif').toPromise();
            return data;
        } catch (e) {
            console.log('banque getList error', e);
            return [];
        }
    }
    getListPaginate(size: number, page: number) {
        return this.apiService.get(this.apiPath + '?size=' + size + '&page=' + page);
    }
    search(libelle: string, size: number, page: number) {
        return this.apiService.get(this.apiPath + '/search?libelle=' + libelle + '&size=' + size + '&page=' + page);
    }
    save(obj: Banque) {
        return this.apiService.post(this.apiPath, obj);
    }
    update(obj: Banque) {
        return this.apiService.put(this.apiPath, obj);
    }
    getElement(id: any) {
        return this.apiService.get(this.apiPath + '/' + id);
    }
    delete(id: any) {
        return this.apiService.delete(this.apiPath + '/' + id);
    }

    
    
}
